import MonthlyScopeGapForecast from '@/models/MonthlyScopeGapForecast';
import ScopeGapItem from '@/models/ScopeGapItem';
import ScopeGapItemService from '@/services/ScopeGapItemService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const useScopeGapItemsStore = defineStore('scope_gap_items', {
  state: () => ({}),

  getters: {
    models: () => useRepo(ScopeGapItem),
  },

  actions: {
    async store(projectId: Id, packageId: Id, request: ApiRequests['api.v1.scope-gap-items.store']) {
      const [data, error] = await ScopeGapItemService.store(projectId, packageId, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async update(id: Id, request: ApiRequests['api.v1.scope-gap-items.update']) {
      const [data, error] = await ScopeGapItemService.update(id, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async sort(id: Id, request: ApiRequests['api.v1.scope-gap-items.sort']) {
      const [data, error] = await ScopeGapItemService.sort(id, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },
  },
});
